export default function SearchItem({ children, ...props }) {
  return (
    <div {...props} className="p-2 cursor-pointer">
      {children}
    </div>
  );
}
